type Unsubscribe = () => void;

export function createStore<T>(initial: T) {
    let value = initial;
    const listeners = new Set<() => void>();

    return {
        getSnapshot: () => value,
        subscribe: (cb: () => void): Unsubscribe => {
            listeners.add(cb);
            return () => listeners.delete(cb);
        },
        set: (next: T) => {
            if (Object.is(value, next)) {
                return;
            }
            value = next;
            for (const listener of listeners) {
                listener();
            }
        },
        update: (fn: (prev: T) => T) => {
            const next = fn(value);
            if (Object.is(value, next)) {
                return;
            }
            value = next;
            for (const listener of listeners) {
                listener();
            }
        },
        reset: (next: T = initial) => {
            value = next;
            for (const listener of listeners) {
                listener();
            }
        },
    };
}
